import { FC } from "react"

export const Logo:FC = () => {
    return (
        <>
            <p className="logo">Sofi_Sova</p>
        </>
    )
}
